module.exports = __webpack_public_path__ + "static/media/PWI_btn_Icon_default_303.b312c9db.svg";